export default "__VITE_ASSET__C2M$Jc2X__"